import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import Countdown from 'react-countdown'
import {
  GUESS_DISTRIBUTION_TEXT,
  NEW_WORD_TEXT,
  SHARE_TEXT,
  STATISTICS_TITLE,
} from '../../constants/strings'
import { GameStats } from '../../lib/localStorage'
import { shareStatus } from '../../lib/share'
import { tomorrow } from '../../lib/words'
import { LusAdDisplay } from '../LusAdDisplay'
import { Histogram } from '../stats/Histogram'
import { StatBar } from '../stats/StatBar'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
  guesses: string[]
  gameStats: GameStats
  isGameLost: boolean
  isGameWon: boolean
  sessionId: string
  handleShare: () => void
}

export const StatsModal = ({
  isOpen,
  handleClose,
  guesses,
  gameStats,
  isGameLost,
  isGameWon,
  sessionId,
  handleShare,
}: Props) => {
  const [isHistogramExpanded, setIsHistogramExpanded] = useState(false)

  if (gameStats.totalGames <= 0) {
    return (
      <BaseModal
        title={STATISTICS_TITLE}
        isOpen={isOpen}
        handleClose={handleClose}
      >
        <div className="flex justify-center mb-4">
          <div className="text-xs text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300">
            Royn <a href="https://ordasnar.fo" target="_blank" rel="noopener noreferrer" className="text-red-600 dark:text-red-400 hover:text-red-700 underline dark:hover:text-red-300">orðasnar.fo</a>
          </div>
        </div>
        <StatBar gameStats={gameStats} />
      </BaseModal>
    )
  }
  return (
    <BaseModal
      title={STATISTICS_TITLE}
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <div className="flex justify-center mb-4">
        <div className="text-xs text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300">
          Royn <a href="https://ordasnar.fo" target="_blank" rel="noopener noreferrer" className="text-red-600 dark:text-red-400 hover:text-red-700 underline dark:hover:text-red-300">orðasnar.fo</a>
        </div>
      </div>
      <StatBar gameStats={gameStats} />

      {/* Collapsible Histogram Section */}
      <div className="mt-4">
        <button
          onClick={() => setIsHistogramExpanded(!isHistogramExpanded)}
          className="flex items-center justify-between w-full text-left text-lg leading-6 font-medium text-gray-900 dark:text-gray-100 hover:text-gray-700 dark:hover:text-gray-300 transition-colors border-0 bg-transparent p-0 focus:outline-none"
        >
          <span>{GUESS_DISTRIBUTION_TEXT}</span>
          {isHistogramExpanded ? (
            <ChevronDownIcon className="h-5 w-5 ml-2" />
          ) : (
            <ChevronRightIcon className="h-5 w-5 ml-2" />
          )}
        </button>

        {isHistogramExpanded && (
          <div className="mt-4">
            <Histogram gameStats={gameStats} />
          </div>
        )}
      </div>
      {(isGameLost || isGameWon) && (
        <div className="mt-4 mb-4">
          <div className="text-xs text-gray-500 dark:text-gray-400 mb-0.5 text-left">
            Lýsing:
          </div>
          <LusAdDisplay
            site="d.fo"
            className="mx-auto"
            containerId="stats-modal-ad-display"
            sessionId={sessionId}
          />
        </div>
      )}
      {(isGameLost || isGameWon) && (
        <div className="mt-5 sm:mt-6 columns-2 dark:text-white">
          <div>
            <h5>{NEW_WORD_TEXT}</h5>
            <Countdown
              className="text-lg font-medium text-gray-900 dark:text-gray-100"
              date={tomorrow}
              daysInHours={true}
            />
          </div>
          <button
            type="button"
            className="mt-2 w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
            onClick={() => {
              shareStatus(guesses, isGameLost)
              handleShare()
            }}
          >
            {SHARE_TEXT}
          </button>
        </div>
      )}
    </BaseModal>
  )
}
